document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', function() {
        const max = parseInt(this.getAttribute('max'), 10);
        if (this.value > max) {
            alert(`You can only add up to ${max} of this item.`);
            this.value = max;
        }
    });
});